export default "__VITE_ASSET__C0d_$pDv__"